import React from "react";
import { Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

const PendingQAndAIndicator = (props) => {

    const {
        value,
        isInstructor,
    } = props;

    if (!value) return null;

    return (
        <Typography variant="caption" style={{ fontWeight: 600 }}>
            - {getLocalizedString(isInstructor ? "questionsWithoutAnswer" : "newAnswersToSee")}
        </Typography>
    );
}

export default PendingQAndAIndicator;